import clsx from 'clsx';

import { IconButton, IconButtonProps } from '../../../components/buttons';
import { X } from '../../../components/icons';
import { classNamesFor } from '../../../utils/classNames';
import { useCloseDialog } from '../hooks/useCloseDialog';
import { DialogResult } from '../types';

const classNamesFactory = classNamesFor('CloseDialogIconButton');

const classNames = {
  root: classNamesFactory.root(),
};

type CloseDialogButtonProps<RESULT> = IconButtonProps & {
  result?: DialogResult<RESULT>;
};

export const CloseDialogButton = <RESULT = unknown,>({
  className,
  result,
  ...rest
}: CloseDialogButtonProps<RESULT>) => {
  const closeDialog = useCloseDialog();
  return (
    <IconButton
      variant="ghost"
      size="sm"
      onClick={() => closeDialog(result)}
      className={clsx(classNames.root, className)}
      testId="close-dialog-button"
      {...rest}
    >
      <X />
    </IconButton>
  );
};

CloseDialogButton.classNames = classNames;
